import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink, ExternalLinkProps } from '@workday/upc-common';
interface Urls {
    [key: string]: {
        privacyUrl: string;
        termsUrl: string;
    };
}
const urls: Urls = {
    en: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    'fr-CA': {
        privacyUrl: 'https://www.workday.com/fr-ca/privacy.html',
        termsUrl: 'https://www.workday.com/fr-ca/legal/site-terms.html'
    },
    fr: {
        privacyUrl: 'https://www.workday.com/fr-fr/privacy.html',
        termsUrl: 'https://www.workday.com/fr-fr/legal/site-terms.html'
    },
    bg: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    ar: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    cs: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    da: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    de: {
        privacyUrl: 'https://www.workday.com/de-de/privacy.html',
        termsUrl: 'https://www.workday.com/de-de/legal/site-terms.html'
    },
    el: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    es: {
        privacyUrl: 'https://www.workday.com/es-es/privacy.html',
        termsUrl: 'https://www.workday.com/es-es/legal/site-terms.html'
    },
    'es-419': {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    et: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    fi: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    he: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    hr: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    hu: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    id: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    it: {
        privacyUrl: 'https://www.workday.com/it-it/privacy.html',
        termsUrl: 'https://www.workday.com/it-it/legal/site-terms.html'
    },
    ja: {
        privacyUrl: 'https://www.workday.com/ja-jp/privacy.html',
        termsUrl: 'https://www.workday.com/ja-jp/legal/site-terms.html'
    },
    ko: {
        privacyUrl: 'https://www.workday.com/ko-kr/privacy.html',
        termsUrl: 'https://www.workday.com/ko-kr/legal/site-terms.html'
    },
    lt: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    lv: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    ms: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    nl: {
        privacyUrl: 'https://www.workday.com/nl-nl/privacy.html',
        termsUrl: 'https://www.workday.com/nl-nl/legal/site-terms.html'
    },
    no: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    pl: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    'pt-BR': {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    ro: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    ru: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    sk: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    sl: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    sr: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    sv: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    th: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    tr: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    uk: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    vi: {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    'zh-CN': {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    'zh-HK': {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    },
    'zh-TW': {
        privacyUrl: 'https://www.workday.com/en-us/privacy.html',
        termsUrl: 'https://www.workday.com/en-us/legal/site-terms.html'
    }
};

interface TranslatedExternalLinkProps extends ExternalLinkProps {
    translationKey: keyof Urls;
}

export function TranslatedExternalLink({ translationKey, ...rest }: TranslatedExternalLinkProps) {
    const { i18n } = useTranslation();
    let language = i18n.language ? i18n.language : 'en';
    if (urls[language] === undefined) {
        language = 'en';
    }
    const url = urls[language][translationKey];

    return <ExternalLink href={url} {...rest} />;
}
